import { Injectable } from '@angular/core';
import { Router, RouterEvent, NavigationEnd } from '@angular/router';

/**
 * Сервис для предоставления истории маршрутов
 */
@Injectable(
    {
        providedIn: 'root'
    }
)
export class LocationRouteServiceService {

    private previousUrl: string = undefined;
    private currentUrl: string = undefined;

    constructor(private router: Router) {
        this.currentUrl = this.router.url;
        router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (!event.url.includes('/factor/input/row')) {
                    this.currentUrl = event.url;
                }
                this.previousUrl = this.currentUrl;
            }
        });
    }


    /**
     * Получить предыдущий путь
     */
    public getPreviousUrl() {
        return this.previousUrl;
    }
}
